import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Company } from '@models/companies/company';
import { Document } from '@models/documents/document';
import { EntityChangeData } from '@models/documents/entity-change-data';
import { CompanyChangeData } from '@models/ui-models/company-change-data';
import { CompanySubtype, CompanySubtypeLabels } from '@models/companies/company-enums';
import { ChangeDictionaryHelper } from '@models/ui-models/change-dictionary-helper.model';
import { CompanyChangeSpecialPurposeComponent } from './company-change-special-purpose.component';

export class CompanyChangeSpecialPurpose extends EntityChangeData {
  static override readonly $type = 'CompanyChangeSpecialPurpose';
  newCompanySubtype: CompanySubtype;

  constructor(data: Partial<CompanyChangeSpecialPurpose> = {}) {
    super(data);

    this.newCompanySubtype = data.newCompanySubtype ?? CompanySubtype.PROP;
  }

  override toDictionary(): { key: string; value: string; }[] {
    const dict = new ChangeDictionaryHelper();
    const isCease = this.newCompanySubtype === CompanySubtype.PROP;

    dict.add('The Change is', isCease ? 'Cease' : 'Commence');

    if (!isCease) dict.add('New Company Subtype', CompanySubtypeLabels[this.newCompanySubtype]);

    dict.addDate('Date of Change', this.changeDate);

    return dict.dictionary;
  }

  override fillModal(modalRef: NgbModalRef, document: Document, actualCompany: Company): NgbModalRef {
    modalRef = this.fillModalWithCompany(modalRef, actualCompany, true);
    (modalRef.componentInstance as CompanyChangeSpecialPurposeComponent).companyChangeData.documentId = document.documentId;
    return modalRef;
  }

  fillModalWithCompany(modalRef: NgbModalRef, company: Company, isEdit = false): NgbModalRef {
    const instance = modalRef.componentInstance as CompanyChangeSpecialPurposeComponent;

    if (!isEdit) {
      this.newCompanySubtype = company.companySubtype!;
    }

    instance.isEdit = isEdit;
    instance.companyChangeData = new CompanyChangeData(company);
    instance.formModel = structuredClone(this);

    return modalRef;
  }
}
